<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" label-width="120px">
    
      <el-row>
        <el-col :span="8">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="dataForm.name" placeholder="姓名"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="手机号码" prop="phone">
            <el-input v-model="dataForm.phone" placeholder="手机号码"></el-input>
          </el-form-item>
        </el-col> 
        <el-col :span="8">
          <el-form-item label="手机Md5" prop="mobileMd5Value">
            <el-input v-model="dataForm.mobileMd5Value" placeholder="手机号码"></el-input>
          </el-form-item>
        </el-col> 
           <el-col :span="8">
          <el-form-item label="性别" prop="sex">
            <el-select v-model="dataForm.sex" filterable clearable placeholder="请选择">
              <el-option
                v-for="item in sexList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item>
          <el-select v-model="dataForm.city" filterable clearable placeholder="城市">
            <el-option
              v-for="item in citys"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        </el-col>
      </el-row>
          <el-form-item label="任务ID" prop="taskId">
        <el-input v-model="dataForm.taskId" placeholder="任务ID"></el-input>
      </el-form-item>
      
      <el-form-item label="任务名称" prop="taskName">
        <el-input v-model="dataForm.taskName" placeholder="任务名称"></el-input>
      </el-form-item>
      <el-form-item label="话单意向" prop="grade">
        <el-select v-model="dataForm.grade" placeholder="请选择">
          <el-option label="A级" value="A"></el-option>
          <el-option label="B级" value="B"></el-option>
          <el-option label="C级" value="C"></el-option>
          <el-option label="D级" value="D"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="通话时长(秒)" prop="duration">
        <el-input-number v-model="dataForm.duration" controls-position="right" :min="0"></el-input-number>
      </el-form-item>
      <el-row>
        <el-col :span="8">
          <el-form-item label="是否呼通" prop="isCallSuccess">
            <el-radio-group v-model="dataForm.isCallSuccess">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      
        <el-col :span="8">
          <el-form-item label="是否有呼损" prop="isCallLoss">
              <el-radio-group v-model="dataForm.isCallLoss">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
      </el-row>
  
    
            

      <el-form-item label="挂机原因" prop="hangupReason">
        <el-input v-model="dataForm.hangupReason" placeholder="挂机原因"></el-input>
      </el-form-item>

      <el-form-item label="录音URL" prop="audio">
        <el-input v-model="dataForm.audio" placeholder="录音URL"></el-input>
      </el-form-item>

      <el-form-item label="跟进用户昵称" prop="ccName">
        <el-input v-model="dataForm.ccName" placeholder="跟进用户昵称"></el-input>
      </el-form-item>
      <el-form-item label="通话内容" prop="detail">
        <el-input type="textarea" v-model="dataForm.detail" placeholder="通话内容"></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input type="textarea" v-model="dataForm.remark" placeholder="备注"></el-input>
      </el-form-item>
      <el-row>
        <el-col :span="8">
          <el-form-item label="是否推送" prop="isPush">
            <el-radio-group v-model="dataForm.isPush">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      
        <el-col :span="8">
          <el-form-item label="状态" prop="status">
            <el-radio-group v-model="dataForm.status">
              <el-radio :label="1">有效</el-radio>
              <el-radio :label="0">无效</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    data () {
      return {
        visible: false,
        sexList: [
        {
          label: "男",
          value: "男",
        },
        {
          label: "女",
          value: "女",
        },
      ],
        citys: [], // 1. 定义城市列表数组
        dataForm: {
          id: '',
          taskId: '',
          taskName: '',
          phone: '',
          mobileMd5Value: '',
          name: '',
          sex: '',
          city: '',
          detail:'',
          mobileMd5Value: '',
          grade: '',
          duration: 0,
          isCallSuccess: 0,
          isCallLoss: 0,
          hangupReason: '',
          audio: '',
          ccName: '',
          remark: '',
          status: 1,
          isPush: 1
        },
        dataRule: {
          phone: [
            { required: true, message: '手机号码不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      // 2. 添加获取城市数据的方法
      getCityOptions() {
        this.$http.get(`/sys/dict/data/list?dataType=landing_page_city`).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.citys = [];
          if (res.data != null) {
            res.data.forEach(element => {
              this.citys.push({ label: element.dictLabel, value: element.dictValue })
            })
          }
        }).catch(() => {})
      },

      init (id) {
        this.dataForm.id = id || ''
        this.visible = true
        
        // 3. 调用获取城市数据
        this.getCityOptions();

        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields()
          if (this.dataForm.id) {
            // 获取详情接口，请根据实际后端调整
            this.$http.get(`/sys/customersai/${this.dataForm.id}`).then(({data: res}) => {
              if (res.code !== 0) {
                return this.$message.error(res.msg)
              }
              this.dataForm = {
                ...this.dataForm,
                ...res.data
              }
            })
          }
        })
      },
      // 表单提交
      dataFormSubmitHandle () {
        this.$refs['dataForm'].validate((valid) => {
          if (!valid) {
            return false
          }
          // 根据是否有ID判断是新增还是修改
          this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/customersai', this.dataForm).then(({data: res}) => {
            if (res.code !== 0) {
              return this.$message.error(res.msg)
            }
            this.$message({
              message: this.$t('prompt.success'),
              type: 'success',
              duration: 500,
              onClose: () => {
                this.visible = false
                this.$emit('refreshDataList')
              }
            })
          })
        })
      }
    }
  }
</script>